import type { PersonalTaxFactsInput } from '../track-b2';

export interface PersonalTaxEngineFacts {
  kind: 'PIT';
  grossIncomeKobo: string;
  pensionKobo: string;
  nationalHousingFundKobo: string;
  nationalHealthInsuranceKobo: string;
  ownerOccupiedMortgageInterestKobo: string;
  lifeInsurancePremiumKobo: string;
  annualRentPaidKobo: string;
  taxCreditsKobo: string;
}

export async function bindPersonalTaxFacts(facts: PersonalTaxFactsInput, periodStart: string,
  binding?: { taxpayerId: string; engagementId?: string }): Promise<{ engineFacts: PersonalTaxEngineFacts;
    factSnapshotSha256: string }> {
  const engineFacts: PersonalTaxEngineFacts = { kind: 'PIT', grossIncomeKobo: nairaToKobo(facts.grossIncomeNaira),
    pensionKobo: nairaToKobo(facts.pensionNaira), nationalHousingFundKobo: nairaToKobo(facts.nationalHousingFundNaira),
    nationalHealthInsuranceKobo: nairaToKobo(facts.nationalHealthInsuranceNaira),
    ownerOccupiedMortgageInterestKobo: nairaToKobo(facts.ownerOccupiedMortgageInterestNaira),
    lifeInsurancePremiumKobo: nairaToKobo(facts.lifeInsurancePremiumNaira), annualRentPaidKobo: nairaToKobo(facts.annualRentPaidNaira),
    taxCreditsKobo: nairaToKobo(facts.taxCreditsNaira) };
  return { engineFacts, factSnapshotSha256: await sha256(JSON.stringify({ packageId: facts.packageId,
    periodStart, ...(binding ? { binding } : {}), facts: engineFacts })) };
}

export function formatKobo(value: string): string {
  const amount = BigInt(value); const whole = amount / 100n; const fraction = (amount % 100n).toString().padStart(2, '0');
  return `₦${whole.toLocaleString('en-NG')}.${fraction}`;
}

export function koboToNaira(value: string): string {
  if (!/^(0|[1-9]\d*)$/.test(value)) throw new Error('Saved personal-tax amount is invalid.');
  const amount = BigInt(value); const whole = amount / 100n; const fraction = amount % 100n;
  return fraction === 0n ? whole.toString() : `${whole}.${fraction.toString().padStart(2, '0').replace(/0$/, '')}`;
}

function nairaToKobo(value: string): string {
  if (!/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(value)) throw new Error('Enter each amount as naira with no more than two decimal places.');
  const [whole = '0', fraction = ''] = value.split('.');
  return (BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'))).toString();
}

async function sha256(value: string): Promise<string> {
  const bytes = new TextEncoder().encode(value); const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
